import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";

class Intervenant extends Component {
  render() {
    return (
      <section className="landing-section landing-split" id="intervenant">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <span className="landing-eyebrow">Collaboration</span>
              <h2>Une relation école-parent plus directe et plus transparente.</h2>
              <p className="landing-lead">
                Les informations importantes circulent plus vite : progression de l’élève, paiements, discipline,
                annonces et suivi quotidien.
              </p>

              <div className="landing-check-list">
                <div>
                  <FeatherIcon icon="user-check" size={19} />
                  <span>Accès réservé aux parents et intervenants autorisés.</span>
                </div>
                <div>
                  <FeatherIcon icon="bell" size={19} />
                  <span>Notifications utiles pour les paiements et événements scolaires.</span>
                </div>
                <div>
                  <FeatherIcon icon="repeat" size={19} />
                  <span>Communication plus simple entre administration, enseignants et familles.</span>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="landing-image-frame">
                <img className="img-fluid" src="assets/img/validation/validation.png" alt="Collaboration scolaire" />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Intervenant;
